class Client {
  constructor(data) {
    data              = data || {};
    this.id           = data.id || null;
    this.markets      = data.markets || [];
    this.name         = data.name || null;
    this.host_prefix  = data.host_prefix || null;
    this.venue_types  = data.venue_types || [];
    // "Use Event Name" setting - drives whether the ad-hoc form collects a name.
    this.events_has_name = data.events_has_name || false;
    // Ad-hoc event creation: hide the time inputs and use now + duration.
    this.staff_adhoc_hide_times       = data.staff_adhoc_hide_times || false;
    this.staff_adhoc_hidden_duration  = data.staff_adhoc_hidden_duration || 0;
    // Ad-hoc event creation: hide the description field.
    this.staff_adhoc_hide_description = data.staff_adhoc_hide_description || false;
    // Ad-hoc event creation: the client's default start/end (HH:mm), null when unset.
    this.events_default_start = data.events_default_start || null;
    this.events_default_end   = data.events_default_end || null;
    // Field Staff Settings: show the Products button on shift cards.
    this.staffing_show_products_button = data.staffing_show_products_button || false;
    // Nearby search: also list Google places that are not in the system.
    this.staff_can_search_nearby_google_places = data.staff_can_search_nearby_google_places || false;
  }
}

export default Client;
